import { ApiUrls } from '../endpoints';
import api from '../createApiClient';

export const getCompanyBadgeProfile = async (ProfileID) => {
  try {
    const dataUrl = `${ApiUrls.company}/getCompanyBadgeProfile/${ProfileID}`;
    const response = await api.get(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error getting company badge profile:', error);
    throw error;
  }
};

export const getAllCompanies = async () => {
  try {
    const dataUrl = `${ApiUrls.company}/getAllCompanies`;
    const response = await api.get(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error getting all companies:', error);
    throw error;
  }
};

export const getAllCompaniesByIssuer = async (IssuerID) => {
  try {
    const dataUrl = `${ApiUrls.company}/getAllCompaniesByIssuerId/${IssuerID}`;
    const response = await api.get(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error getting all companies:', error);
    throw error;
  }
};

export const getCompany = async (CompanyID) => {
  try {
    const dataUrl = `${ApiUrls.company}/getCompanyById/${CompanyID}`;
    const response = await api.get(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error getting company:', error);
    throw error;
  }
};

export const createCompany = async (data) => {
  try {
    const dataUrl = `${ApiUrls.company}/createCompany`;
    const response = await api.post(dataUrl, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error creating company:', error);
    throw error;
  }
};

export const updateCompany = async (data) => {
  try {
    const dataUrl = `${ApiUrls.company}/updateCompanyById`;
    const response = await api.post(dataUrl, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating company:', error);
    throw error;
  }
};

export const deleteCompany = async (CompanyID) => {
  try {
    const dataUrl = `${ApiUrls.company}/deleteCompanyById/${CompanyID}`;
    const response = await api.delete(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error deleting company:', error);
    throw error;
  }
};

export const deleteAllCompanies = async () => {
  try {
    const dataUrl = `${ApiUrls.company}/deleteAllCompanies`;
    const response = await api.delete(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error deleting all companies:', error);
    throw error;
  }
};
